import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { capitalizeFirstLetter } from '../../rechercheContact/utils/rechercheContactUtils'
import { RefusRDVEnum } from '../enums/refusRDVEnum'
import { Grid } from '@mui/material'

interface AcceptingProps {
	refusRDV: RefusRDVEnum
}

const PriseRdvIndisponible: FC<AcceptingProps> = ({ refusRDV }) => {
	const { classes, cx } = useStyles()

	const popInEndTitleClass = cx(
		classes.colorAccessibility,
		classes.title2
	)

	const popInDescriptionClass = cx(
		classes.text20,
		classes.description
	)

	return (
		<Grid container className={classes.popInContainerStyle}>
			<Grid item container xs={10} alignItems="center">
				<span className={popInEndTitleClass}>
					<FormattedMessage
						id="visites.popin.refus.titre"
						defaultMessage="Réservation non autorisée"
						description="Dialog title"
					/>
				</span>
			</Grid>
			<Grid item xs={12} className={classes.message}>
				<span className={popInDescriptionClass}>
					<FormattedMessage
						id={`visites.popin.refus.description${capitalizeFirstLetter(refusRDV as RefusRDVEnum)}`}
						defaultMessage="Vous avez déjà pris rendez-vous pour visiter ce bien. Vous pouvez modifier ce rendez-vous si le créneau ne vous convient plus."
						description="Login necessary"
					/>
				</span>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	popInContainerStyle: {
		padding: '20px 24px'
	},
	message: {
		marginTop: 30
	},
	description: {
		whiteSpace: 'break-spaces'
	}
}))

export default PriseRdvIndisponible
